import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { cssClass } from '~src/style';

import { LinkedTaskDeleteButton } from './LinkedTaskDeleteButton';
import { LinkedTaskItemOptionsBar } from './LinkedTaskItemOptionsBar';
import { LinkedTaskMoveItemButton } from './LinkedTaskMoveItemButton';

export const numberWidth = 40;
const viewingNumberWidth = 20;
export const numberMargin = 6;

const wrapperStyle = style({
  display: 'flex',
});

const innerWrapperStyle = style({
  padding: `${TabStyles.Spacing.SmallSpace}px`,
  border: `1px solid ${TabStyles.Colors.L6}`,
  flex: '1 1 auto',
  display: 'flex',
});

export const numberStyle = style({
  width: numberWidth,
  textAlign: 'center',
  flex: '0 0 auto',
  display: 'inline-flex',
  marginRight: numberMargin,
});

export const viewingNumberClass = cssClass('viewingNumberClass', numberStyle, {
  width: viewingNumberWidth,
});

const titleStyle = style({
  margin: `0 ${TabStyles.Spacing.DefaultSpace}px`,
});

const contentStyle = style({
  margin: `0 ${TabStyles.Spacing.DefaultSpace}px`,
  flex: '1 1 auto',
});

export type LinkedTaskItemProps = {
  index: number;
  title: string;
  content?: React.ReactNode;
  buttonType?: 'edit' | 'view' | 'delete';
  expansionContent?: React.ReactNode;
  onDelete?: () => void;
  isExpanded?: boolean;
  setIsExpanded: (index: number, value: boolean) => void;
  flowName?: string;
}

export function LinkedTaskItem(props: LinkedTaskItemProps): JSX.Element {
  function setIsExpanded(value: boolean) {
    props.setIsExpanded(props.index, value);
  }

  function renderFlowSelectionItem() {
    switch (props.buttonType) {
      case 'edit':
        return <LinkedTaskItemOptionsBar isExpanded={props.isExpanded === undefined ? false : props.isExpanded} setIsExpanded={setIsExpanded} flowName={props.flowName} expansionContent={props.expansionContent} />;
      case 'delete':
        return <>
          {props.content ? props.content :
            <div className={innerWrapperStyle}>
              <div className={titleStyle}>{props.title}</div>
              <span className={contentStyle}>{props.content}</span>
            </div>}
          {<LinkedTaskDeleteButton onDelete={props.onDelete} />}
        </>;
      default:
        // default type 'view'
        return;
    }
  }

  return (
    <div>
      <div className={wrapperStyle}>
        <div className={numberStyle}>
          <LinkedTaskMoveItemButton index={props.index} />
        </div>
        {renderFlowSelectionItem()}
      </div>
    </div>
  );
}
